import { render, staticRenderFns } from "./PriceListCreate.vue?vue&type=template&id=a764c9a0&scoped=true&"
import script from "./PriceListCreate.vue?vue&type=script&lang=js&"
export * from "./PriceListCreate.vue?vue&type=script&lang=js&"
import style0 from "./PriceListCreate.vue?vue&type=style&index=0&id=a764c9a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a764c9a0",
  null
  
)

export default component.exports